import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { useNavigate } from "react-router-dom";
import { RedirectionPageListAction } from "../../actions/notificationAction";
import { MOBILE_BREAKPOINT,HTTP_STATUS } from "../../constants/constant";
import "./createnotificationexcel.scss";
import { useDispatch } from "react-redux";
import { postCreateNotificationExcel } from "../../actions/notificationAction";
import { notify } from '../../services/notification';
import { getCurrentDate, getCurrentTime } from "../../constants/dateTimeUtils/dateTimeUtils";
import { HiMenu, HiX } from "react-icons/hi";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import * as XLSX from "xlsx";
import useMobileView from "../../constants/useMobileView";


function CreateNotificationExcel() {
  const [isLoading, setIsLoading] = useState(false);
  const [redirectionPagelist, setRedirectionPagelist] = useState([]);
 
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [textCounts, setTextCounts] = useState({ title: 0, body: 0 });
  const {  isSidebarOpen, toggleSidebar } = useMobileView();
  const [showErrorMessage, setShowErrorMessage] = useState(true);

  const [states, setDataStates] = useState({
    title: "",
    body: "",
    starting_date: "",
    starting_time: "",
    notification_excel: "",
    redirection_page: ""
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    GetRedirectionPageListData();
  }, []);

  

  const handleInputChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, "")
    });

    setTextCounts({
      ...textCounts,
      [evt.target.name]: Math.min(value.length, evt.target.name === "title" ? 100 : 300)
    });
  };

  

  const handleFileChange = (evt) => {
    const file = evt.target.files[0];
    if (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        setDataStates((prevState) => ({
          ...prevState,
          notification_excel: file
        }));
        setShowErrorMessage(false);
      } else {
        notify.error("Please upload a valid Excel file (.xls or .xlsx)");
        evt.target.value = "";
        setShowErrorMessage(true);
      }
    }
  };

  async function GetRedirectionPageListData() {
    setIsLoading(true);
    const response = await dispatch(RedirectionPageListAction());
    if (response.status === 200) {
      setIsLoading(false);
      setRedirectionPagelist(response.data.data);
      if (response?.data?.data && response.data.data.length > 0) {
        response.data.data.forEach((val) => {
          if (String(val.page_slug).toLowerCase() === "dashboard") {
            setDataStates((prevState) => ({
              ...prevState,
              redirection_page: val.id
            }));
          }
        });
      }
    } else {
      setIsLoading(false);
    }
  }

  const handleDateChange = (event) => {
    setSelectedTime("");
    const { value } = event.target;
    setSelectedDate(value);
    if (value === getCurrentDate()) {
      setCurrentDateTime(new Date());
    } else {
      setCurrentDateTime(null);
    }
  };

  const handleTimeChange = (event) => {
    const { value } = event.target;
    if (selectedDate === getCurrentDate() && value < getCurrentTime()) {
      setSelectedTime(getCurrentTime());
    } else {
      setSelectedTime(value);
    }
  };

  const createNotification = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    const title = states.title.replace(/\s+/g, ' ').trim();
    const body = states.body.replace(/\s+/g, ' ').trim();
    formData.append("title", title);
    formData.append("body", body);
    formData.append("starting_date", selectedDate);
    formData.append("starting_time", selectedTime);
    formData.append("redirection_page", states.redirection_page);

    if (states.notification_excel) {
      formData.append("notification_excel", states.notification_excel);
    } else {
      notify.error("Please upload an Excel file.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await dispatch(postCreateNotificationExcel(formData));
      setDataStates((prevState) => ({
        title: "",
        body: "",
        notification_excel: "",
        redirection_page: prevState.redirection_page
      }));
      setSelectedDate("");
      setSelectedTime("");
      if (response && response.status === 201 && response.data && response.data.message) {
        notify.success(response.data.message);
        navigate("/notification");
        window.scroll(0, 0);
      }
    } catch (error) {
      notify.error(error.message || error.response?.data?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const [dropdownValue, setDropdownValue] = useState("download_with_mobile");

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setDropdownValue(selectedValue);
  };

  const handleDownloadExcelMobileNumber = () => {
    const data = [{ "mobile number": "7905942873" }];
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelFile = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelFile], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "NotificationTemplate_MobileNumber.xlsx";
    link.click();
    notify.success("Mobile Number Excel file downloaded successfully!");
  };

  const handleDownloadExcelUserId = () => {
    const data = [{ "user id": "10124" }];
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelFile = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelFile], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "NotificationTemplate_UserId.xlsx";
    link.click();
    notify.success("User Id Excel file downloaded successfully!");
  };

  const handleDownload = () => {
    if (dropdownValue === "download_with_mobile") {
      handleDownloadExcelMobileNumber();
    } else if (dropdownValue === "download_with_userid") {
      handleDownloadExcelUserId();
    } else {
      notify.warning("Please select an option to download.");
    }
  };

  return (
    <div className="create-notification-excel">
      <div className="main-content">
        <Header title="Create Notification Excel" />
        <div className="form-container">
          {isLoading ? (
            <Loader />
          ) : (
            <form>
              <div className="final-group">
                <label className="form-label">Download Template</label>
                <div className="download-excel-dropdwon-button">
                  <select
                    name="redirection_page"
                    className="select-dropdown-excel"
                    onChange={handleDropdownChange}
                  >
                    <option value="download_with_mobile">Mobile Number</option>
                    <option value="download_with_userid">User ID</option>
                  </select>
                  <button className="download_excel" onClick={handleDownload}>
                    <img
                      src={Image_Url.EXCEL_LOGO}
                      className="downloads_imgdexcel"
                      alt="Excel Logo"
                    />
                    Download
                  </button>
                </div>
              </div>
              <div className="final-group">
                <label className="form-label-xls">(xls or xlsx format)</label>
              </div>
              <div className="final-group">
                <label className="form-label">Upload Excel File</label>
                <input
                  className="frm-input"
                  placeholder="Upload Excel File"
                  type="file"
                  onChange={handleFileChange}
                />
              </div>
              {showErrorMessage && (
              <div className="create-notifcation-excel-final-group">
                <label className="form-labels"> </label>
                <span style={{ color: "red", transform: "translateY(-2rem)" }}>Please Enter Either Mobile Number or User Id</span>
              </div>
              )}
              <div className="create-notifcation-excel-final-group">
                <label className="form-label">Heading</label>
                <textarea
                  className="form-textarea"
                  placeholder="Heading"
                  name="title"
                  value={states.title}
                  onChange={handleInputChange}
                  maxLength={100}
                  id="text2"
                />
              </div>
              <p className='textcount-create-notify-excel-headings text-count-heading-desc montserrat-font'>{Math.min(textCounts.title, 100)}/100</p>
              <div className="create-notifcation-excel-final-group">
                <label className="form-label">Description</label>
                <textarea
                  className="form-textarea"
                  placeholder="Description"
                  name="body"
                  value={states.body}
                  maxLength={300}
                  onChange={handleInputChange}
                  id="text"
                />
              </div>
              <p className='textcount-create-notify-excel-description text-count-heading-desc montserrat-font'> {Math.min(textCounts.body, 300)}/300</p>
              <div className="create-notifcation-excel-final-group">
                <label className="form-label">Select Redirection Page</label>
                <select
                  name="redirection_page"
                  value={states?.redirection_page}
                  onChange={handleInputChange}
                  className="select-dropdown"
                > <option value="">Select Redirection Page</option>
                  {redirectionPagelist.map((data) =>
                    <option key={data.id} value={data.id}>{data.page}</option>
                  )}
                </select>
              </div>
              <div className="create-notifcation-excel-final-group">
                <label className="form-label">Send On Date</label>
                <input
                  type="date"
                  id="date"
                  className="form-input"
                  placeholder="dd/mm/yyyy"
                  name="starting_date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  min={getCurrentDate()}
                />
              </div>
              <div className="create-notifcation-excel-final-group">
                <label className="form-label">Send at Time</label>
                <input
                  type="time"
                  className="form-input"
                  value={selectedTime}
                  onChange={handleTimeChange}
                  disabled={!selectedDate}
                />
              </div>
              <div className="butt-group">
                <button
                  type="button"
                  onClick={() => navigate("/notification")}
                  className="button-close"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="button-send"
                  onClick={createNotification}
                  disabled={
                    states.title === "" ||
                    states.body === "" ||
                    selectedDate === "" ||
                    selectedTime === "" ||
                    states.redirection_page === "" ||
                    states.notification_excel === ""
                  }
                >
                  Send
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateNotificationExcel;





